export default __webpack_public_path__ + "static/media/image1.1f46b6f1.jpg";